import { Injectable } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PaymentLiberationComponent } from '../../../components/payment-liberation/payment-liberation.component';

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationService {
  private modalRef!: NgbModalRef;

  constructor(
    private modalService: NgbModal, private modalConfig: NgbModalConfig
  ) { 
    this.modalConfig.backdrop = 'static';
    this.modalConfig.keyboard = false;
  }

  open() {
    this.modalRef = this.modalService.open(PaymentLiberationComponent, { size: 'l' });
    this.modalRef.componentInstance.ngbModalRef = this.modalRef
  }
}
